<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Title' | translate}}</h2>
  </div>
</div>


<div class="row">
  <!--Nome-->
  <div class="col-sm-8">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('beneficiaryName')" >
        <label for="name"  [ngClass]="{'disabled': isFieldDisabled('beneficiaryName')}">
          <span  class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Name' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right"
                 type="text"
                 [(ngModel)]="cardData.beneficiaryName"
                 #name="ngModel"
                 name="name"
                  maxlength="60"
                 required
                 messageFieldType="string">
          <validation-message [control]="name"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Data de Nascimento-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('dateOfBirth') || personTypologyCode==personTypesValues.Colectiva">
        <label for="dateOfBirth"  [ngClass]="{'disabled': isFieldDisabled('dateOfBirth')}">
          <span class="mandatory"
              *ngIf="personTypologyCode==personTypesValues.Singular">*</span>
         {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.DateOfBirth' | translate}}
        </label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpDateOfBirth="bsDatepicker"
                   bsDatepicker
                   type="text"
                   autocomplete="off"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   class="form-control DatepickerCustomClasse"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [(ngModel)]="cardData.dateOfBirth"
                   name="dateOfBirth"
                   maxlength="10"
                   [required]="personTypologyCode==personTypesValues.Singular"
                   readonly
                   #dateOfBirth="ngModel" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="dateOfBirth"></validation-message>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>

<div class="row">

  <!--Tem nacionalidade portuguesa?-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('hasNacPT') || personTypologyCode==personTypesValues.Colectiva">
        <label for="hasPortugueseNationality" [ngClass]="{'disabled': isFieldDisabled('hasNacPT')}">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasNacPT?.toString()"
                 [radioLabel]="hasPortugueseNationality">
            <input type="radio"
                   [(ngModel)]="cardData.hasNacPT"
                   name="hasPortugueseNationality"
                   [clearRelated]="{model : this.cardData , propsToReset : ['identificationNumberFirst','identificationNumberLast']}"
                   [required]="personTypologyCode==personTypesValues.Singular"
                   #hasLegalRepresentation="ngModel"
                   [value]="domain.value">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          <!--<span>cardData.hasNacPT:{{cardData.hasNacPT}}</span>-->
        </div>
      </fieldset>
    </div>
  </div>

  <!--Tem nif portugues?-->
  <!--<div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('hasNIFPT')">
        <label for="hasPortugueseNif"  [ngClass]="{'disabled': isFieldDisabled('hasNIFPT')}">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory" disabled>*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNif' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasNIFPT?.toString()"
                 [radioLabel]="hasPortugueseNif">
            <input type="radio"
                   [(ngModel)]="cardData.hasNIFPT"
                   name="hasPortugueseNif"
                   [required]="personTypologyCode==personTypesValues.Singular"
                   #hasLegalRepresentation="ngModel"
                   [value]="domain.value">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>-->

  <!--Nacionalidade-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('nationality') || personTypologyCode!=personTypesValues.Singular ||  !isStateRLDiferido()">
        <label for="nationality"
               [class.disabled]=" isFieldDisabled('nationality') || personTypologyCode!=personTypesValues.Singular  ||  !isStateRLDiferido()">
          <span *ngIf="personTypologyCode==personTypesValues.Singular " class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Nationality' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.nationality"
                name="nationalityCode"
                #nationalityCode="ngModel"
                [required]="personTypologyCode==personTypesValues.Singular"
                [dropdownTitle]="{value : cardData.nationality, dimension : nationalities }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of nationalities" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="nationalityCode"></validation-message>
      </fieldset>
    </div>
  </div>



</div>

<div class="row">

  <!--Genero-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('gender')  || personTypologyCode!=personTypesValues.Singular">
        <label for="Gender" [ngClass]="{'disabled': isFieldDisabled('gender')}">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Gender' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.gender"
                name="gender"
                [required]="personTypologyCode==personTypesValues.Singular"
                #gender="ngModel"
                [dropdownTitle]="{value : cardData.gender, dimensions :  genders }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of genders" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="gender"></validation-message>
      </fieldset>
    </div>
  </div>

  @if(!hasCivilState()){
  <!--Estado civil na data do óbito-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="civilStateDeathDate">
        <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilStateDeathState' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.civilStateDeathDate"
              name="civilStateDeathDate"
              #civilStateDeathDate="ngModel"
              [required]="personTypologyCode==personTypesValues.Singular"
              [disabled]="personTypologyCode!=personTypesValues.Singular"
              nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of maritalStatus" [value]="domain.description">
          {{domain.value}}
        </option>
      </select>
      <validation-message [control]="civilStateDeathDate"></validation-message>
    </div>
  </div>
  }
  @if(hasCivilState()){
  <!--Estado civil -->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="civilState"
             [class.disabled]="isFieldDisabled('civilState')  || personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()">
        <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilState' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.civilState"
              name="civilState"
              disabled
              #civilStateDeathDate="ngModel"
              [required]="personTypologyCode==personTypesValues.Singular"
              [disabled]="isFieldDisabled('civilState')  || personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()"
              nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of maritalStatusSingle" [value]="domain.description">
          {{domain.value}}
        </option>
      </select>
      <validation-message [control]="civilState"></validation-message>
    </div>
  </div>

  <!--Estado civil na data do óbito-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="civilStateDeathDate"  [class.disabled]="personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()">
        <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilStateDeathState' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.civilStateDeathDate"
              name="civilStateDeathDate"
              #civilStateDeathDate="ngModel"
              [required]="personTypologyCode==personTypesValues.Singular"
              [disabled]="personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()"
              nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of maritalStatus" [value]="domain.description">
          {{domain.value}}
        </option>
      </select>
      <validation-message [control]="civilStateDeathDate"></validation-message>
    </div>
  </div>



  }
</div>




<div class="row">
  <!--Tipo de documento de identificação-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('identificationDocumentType')   || personTypologyCode!=personTypesValues.Singular">
        <label for="DocumentType" [class.disabled]=" isFieldDisabled('identificationDocumentType')   || personTypologyCode!=personTypesValues.Singular">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationDocumentType' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.identificationDocumentType"
                name="identificationDocumentType"
                #identificationDocumentType="ngModel"
                [required]="personTypologyCode==personTypesValues.Singular"
                [dropdownTitle]="{value : cardData.identificationDocumentType, dimensions : documentTypes }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of documentTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="identificationDocumentType"></validation-message>
      </fieldset>
    </div>
  </div>

  <!--Número de identificação-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('identificationNumberFirst')   || personTypologyCode!=personTypesValues.Singular">
        <label for="identificationNumber" [class.disabled]=" isFieldDisabled('identificationNumberFirst')   || personTypologyCode!=personTypesValues.Singular">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationNumber' | translate}}
        </label>
        @if(cardData.identificationDocumentType !='P' ){
        <div class="form-row">
          <div class="col-sm-9">
            <input class="form-control"
                   type="text"
                   numeric="8"
                   [(ngModel)]="cardData.identificationNumberFirst"
                   name="identificationNumberFirst"
                   [required]="personTypologyCode==personTypesValues.Singular"
                   #identificationNumberFirst="ngModel"
                   maxlength="8">
          </div>
          <div class="col-sm-3">
            <input class="form-control"
                   type="text"
                   maxlength="4"
                   [(ngModel)]="cardData.identificationNumberLast"
                   name="identificationNumberLast"
                   #identificationNumberLast="ngModel">
          </div>
        </div>
        <validation-message [control]="identificationNumberFirst"></validation-message>
        } @else {
        <div class="form-row">
          <div class="col-sm-9">
            <input class="form-control"
                   type="text"
                   mask="A*"
                   [(ngModel)]="cardData.identificationNumberFirst"
                   name="identificationNumberFirst"
                   [required]="personTypologyCode==personTypesValues.Singular"
                   #identificationNumberFirst="ngModel"
                   maxlength="10">
          </div>
          <div class="col-sm-3">
            <input class="form-control"
                   type="text"
                   maxlength="4"
                   [(ngModel)]="cardData.identificationNumberLast"
                   name="identificationNumberLast"
                   #identificationNumberLast="ngModel">
          </div>
        </div>
        <validation-message [control]="identificationNumberFirst"></validation-message>
        }
      </fieldset>
    </div>
  </div>

  <!--NIF-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!(cardData.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF')">
        <label for="NIF" [ngClass]="{'disabled': !(cardData.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF')}">
          <span *ngIf="cardData.hasNIFPT?.toString()==='true'" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}
        </label>
        <input class="form-control"
               type="number"
               numeric="9"
               [(ngModel)]="cardData.NIF"
               name="NIF"
               #NIF="ngModel"
               maxlength="9"
               [required]="cardData.hasNIFPT?.toString()==='true'">
        <validation-message [control]="NIF"></validation-message>
      </fieldset>
    </div>
  </div>

</div>

<div class="row">

  <!--Número de beneficiário-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('NISS') || personTypologyCode!=personTypesValues.Singular  || !isStateRLDiferido()" >
        <label for="NISS"  [class.disabled]=" isFieldDisabled('NISS') || personTypologyCode!=personTypesValues.Singular  || !isStateRLDiferido()">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NISS' | translate}}
        </label>
        <input class="form-control"
               type="number"
               numeric="11"
               [(ngModel)]="cardData.NISS"
               name="NISS"
                  [required]="personTypologyCode==personTypesValues.Singular"
               #NISS="ngModel"
               maxlength="11">
        <validation-message [control]="NISS"></validation-message>
      </fieldset>
    </div>
  </div>

  <!--Serviço de finanças-->
  <div class="col-sm-8">
    <div class="form-group">
      <fieldset [disabled]="isFieldDisabled('financialService') || personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()" >
        <label for="TaxServiceCode" [class.disabled]=" isFieldDisabled('financialService') || personTypologyCode!=personTypesValues.Singular   || !isStateRLDiferido()">
          <span *ngIf="personTypologyCode==personTypesValues.Singular" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.FinancialService' | translate}}
          <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.FinantialServiceTooltip' | translate}}"></span>
        </label>
        <div class="form-row">
          <div class="col-sm-2">
            <input class="form-control"
                   type="text"
                   numeric="4"
                    [required]="personTypologyCode==personTypesValues.Singular"
                   [(ngModel)]="cardData.financialService"
                   name="financialService"
                   #financialService="ngModel"
                   maxlength="4"
                   minlength="2"
                   (blur)="onTaxServiceCodeChanged()" />
          </div>
          <div class="col-sm-10">
            <input class="form-control"
                   type="text"
                   maxlength="60"
                   [(ngModel)]="cardData.financialServiceLast"
                   name="finantialServiceLast"
                   #finantialServiceLast="ngModel"
                   disabled>
          </div>
        </div>
        <validation-message *ngIf="taxServiceFound !== false" [control]="financialService"></validation-message>
        <div *ngIf="taxServiceFound === false" class="invalid-feedback" style="font-size:12px; font-weight:normal;">Código de Serviço de finanças inválido</div>
      </fieldset>
    </div>
  </div>
</div>
